// hardcoded for now so needs to be adjusted every year
const config = {
  measuredValueHistoricalYear: 2020,
  measuredValueCompareYear: 2022,
  measuredValueCurrentYear: 2024,
};

export default config;
